import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ApproacheSection from './components/ApproacheSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <ApproacheSection />
      <CTASection />
      <Footer />
    </main>
  );
}